
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundles/shop/[category]",
      function () {
        return require("private-next-pages/bundles/shop/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundles/shop/[category]"])
      });
    }
  